<template>
  <path pid="0" d="M17.83 13.83a4 4 0 01-6-.43 1 1 0 00-1.6 1.2 6 6 0 009.05.65l3-3a6 6 0 00-8.47-8.5L12 5.47a1 1 0 001.42 1.42l1.72-1.71a4 4 0 015.64 5.67z"/><path pid="1" d="M3.81 22.18a6 6 0 008.41.07L14 20.53a1 1 0 00-1.42-1.42l-1.71 1.71a4 4 0 01-5.64-5.67l3-3a4 4 0 016 .43 1 1 0 001.6-1.2 6 6 0 00-9-.65l-3 3a6 6 0 00-.02 8.45z"/>
</template>
